if (!customElements.get('dates-kit-buy')) {
  customElements.define('dates-kit-buy', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelector('button').addEventListener('click', () => this.buy());
    }
    async buy() {
      if (this.busy) return;
      this.busy = true;
      const button = this.querySelector('button'), status = this.querySelector('[role=status]');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      status.hidden = true;
      const root = window.Shopify?.routes?.root || '/';
      const json = async (url, options) => {
        const response = await fetch(url, options);
        let body;
        try { body = await response.json(); }
        catch { throw Error('Não foi possível atualizar o carrinho. Atualize a página e tente novamente.'); }
        if (!response.ok) throw Error(body.description || 'Não foi possível atualizar o carrinho. Tente novamente.');
        return body;
      };
      try {
        let cart = await json(root + 'cart.js');
        const variant = Number(this.dataset.variant);
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {bubbles:true, detail:{sections}}));
        if (variant !== 50882157412646 || !cart.items.some(item => item.variant_id === variant)) {
          const added = await json(root + 'cart/add.js', {
            method:'POST', headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
            body:JSON.stringify({items:[{id:variant, quantity:1}], sections, sections_url:location.pathname})
          });
          cart = await json(root + 'cart.js');
          cart.sections = added.sections;
        } else {
          const url = new URL(root, location.origin);
          url.searchParams.set('sections', sections.join(','));
          cart.sections = sections.length ? await json(url) : {};
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {bubbles:true, detail:{baseEvent:'variant:add',cart}}));
        const drawer = document.getElementById('cart-drawer');
        if (drawer && typeof drawer.show === 'function') drawer.show();
        else location.assign(root + 'cart');
      } catch (error) {
        status.textContent = error.message;
        status.hidden = false;
      } finally {
        this.busy = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }
  });
}
